/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../Provider";
import { CalendarIcon } from "../../assets/svg/calendarIcon";
import AGSelect from "../../components/AgSelect";
import ScrollToTop from "../../components/ScrollToTop";
import { useUserMappingRoles } from "../../hook/useUserMappingRoles";
import { IDashboardIndexProps } from "./dashboard.props";
import { Container } from "./dashboard.styled";
import { InterestByAreasExpertise } from "./interestByAreasExpertise";
import { InterestByLocation } from "./interestByLocation";
import { MessageReceived } from "./messageReceived";
import { Overview } from "./overview";
import { SearchBySpecialty } from "./searchBySpecialty";
import { TotalVisits } from "./totalVisits";
import { OFFERING_TYPE } from "../../utils/constant";
import { AddIconDatePickerBlack } from "../../components/AddIconDatePicker";

export const DashboardIndex: React.FC<IDashboardIndexProps> = ({
    isAllowMobile = true,
    isHidden = false,
    exportToPDF,
    comOfferingTypes,
    orgFilters,
    orgFilter,
    setOrgFilter,
    filterByTimeOptions,
    filterByTime,
    setfilterByTime,
    chooseComOfferingType,
    setChooseComOfferingType,
    ...props
}) => {
    const user = useContext(UserContext);
    const [handleMappingRoles,] = useUserMappingRoles();

    const elementRef = useRef<HTMLDivElement | null>(null);
    const [height, setHeight] = useState<number>(0);

    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const isMobileScreenPage = screenWidth < 769;


    const navigate = useNavigate();

    useEffect(() => {
        const element = elementRef.current;
        if (!element) return;

        const resizeObserver = new ResizeObserver(entries => {
            for (let entry of entries) {
                setHeight(entry.contentRect.height);
            }
        });
        resizeObserver.observe(element);
        return () => {
            resizeObserver.unobserve(element);
        };
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        if (user && user?.roles.length === 0) {
            navigate("/404");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!user || !filterByTime) {
        return null;
    }

    const renderResponsive = (isRender: boolean, element: any) => {
        return isRender && element
    }

    return !orgFilters ? null : (
        <div className={`${isHidden && "top-[-9999999px] fixed"} mobile2:!pt-[70px]`}>
            <Container id={isHidden ? "captureDesktop" : "capture"} className={`${isHidden ? " !w-[1142px] !max-w-[1142px] !p-[10px]" : "!mb-[20px]"}`} isAllowMobile={isAllowMobile}>
                <ScrollToTop />
                <div className={`${isMobileScreenPage && isAllowMobile && "!items-start"}  flex justify-between items-center  mt-[15px]`}>

                    <div className={`${renderResponsive(isAllowMobile, "")} ${isMobileScreenPage && isAllowMobile && "!flex-col"} flex-1 flex flex-nowrap justify-start`}>
                        {
                            handleMappingRoles(
                                ["Admin"],
                            ) && <div className={`${isMobileScreenPage && isAllowMobile && "!mb-[20px]"} flex flex-nowrap justify-start items-center flex-shrink-0 w-full max-w-[270px] mr-[20px]`}>
                                <p className={`${!isAllowMobile && "mb-[10px]"} text-nowrap  mr-[10px] text-[14px] text-[#666] font-bold inline-block whitespace-nowrap`}>Filter by:</p>
                                <AGSelect
                                    className="!w-[100%]"
                                    options={orgFilters}
                                    value={orgFilter}
                                    isAllowMobile={isAllowMobile}
                                    onChange={(option) => {
                                        if (option) {
                                            setOrgFilter(option as any);
                                        }
                                    }}
                                />
                            </div>
                        }
                        <div className="w-full">
                            <AddIconDatePickerBlack>
                                <AGSelect
                                className={`${isMobileScreenPage && isAllowMobile && "!m-0"}  !w-[100%] max-w-[270px]`}
                                options={filterByTimeOptions}
                                value={filterByTime}
                                isAllowMobile={isAllowMobile}
                                onChange={(option) => {
                                    if (option) {
                                        setfilterByTime(option as any);
                                    }
                                }}
                                isIconStart = {true}
                                />
                            </AddIconDatePickerBlack>
                        </div>
                    </div>
                    {
                        isAllowMobile && <a
                            role="button"
                            onClick={() => exportToPDF && exportToPDF()}
                            className={`${isMobileScreenPage && isAllowMobile && "!mt-[10px] !ml-[10px]"} focus:ring focus:ring-blue-300 link-redirect whitespace-nowrap font-bold`}
                        >
                            Export to PDF
                        </a>
                    }
                </div>
                <Overview interval={filterByTime.value!} isAllowMobile={isAllowMobile} orgFilter={orgFilter} />
                <div className={`!w-[100%] h-[34px] mt-[15px] max-w-[270px]`}>
                    <AGSelect
                        options={comOfferingTypes}
                        isAllowMobile={isAllowMobile}
                        value={chooseComOfferingType}
                        onChange={(option: any) => {
                            if (option) {
                                setChooseComOfferingType(option);
                            }
                        }}
                    />
                </div>
                <div className="wrap-1">
                    <div ref={elementRef} className="wrap-1-left h-auto" style={{ minHeight: 200, maxHeight: isAllowMobile ? 500 : "100%" }} >
                        <MessageReceived comOfferingType={chooseComOfferingType} isAllowMobile={isAllowMobile} orgFilter={orgFilter} />
                    </div>
                    {height !== 0 && (<div style={{ minHeight: 200, maxHeight: isAllowMobile ? 500 : "100%" }} className="wrap-1-right h-auto">
                        <SearchBySpecialty interval={filterByTime.value!} comOfferingType={chooseComOfferingType} orgFilter={orgFilter} />
                    </div>)}
                </div>
                <div className={`${renderResponsive(isAllowMobile, "mobile2:flex-col")} 
                    ${chooseComOfferingType && chooseComOfferingType.value !== OFFERING_TYPE.SECONDMENT && "wrap-2"} 
                    ${isMobileScreenPage && isAllowMobile && "mt-[20px]"} 
                    flex flex-row  gap-5 min-h-[280px] h-full 
                    `}>
                    {
                        chooseComOfferingType && chooseComOfferingType.value !== OFFERING_TYPE.SECONDMENT && <div className="wrap-2-left h-auto ">
                            <InterestByAreasExpertise
                                interval={filterByTime.value!}
                                comOfferingType={chooseComOfferingType}
                                orgFilter={orgFilter}
                            />
                        </div>
                    }
                    <div
                        className={`${chooseComOfferingType && chooseComOfferingType.value === OFFERING_TYPE.SECONDMENT && "!w-full"}  wrap-2-right h-auto `}>
                        <InterestByLocation interval={filterByTime.value!} comOfferingType={chooseComOfferingType} orgFilter={orgFilter} isAllowMobile={isAllowMobile} />
                    </div>
                </div>
                <div className="wrap-3 h-[280px]">
                    <TotalVisits comOfferingType={chooseComOfferingType} orgFilter={orgFilter} isAllowMobile={isAllowMobile} />
                </div>
            </Container>
        </div>
    )
}

export default React.memo(DashboardIndex);

